import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ImageInterface } from 'src/app/types/image';

export interface ExploreItemInterface {
  subtitle: string;
  img: ImageInterface;
  hyperlink?: string;
}

export interface ExploreInterface {
  items: ExploreItemInterface[];
  title: string;
}

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss'],
})
export class ExploreComponent implements OnInit {
  columnCount: number;

  @Input() node: ExploreInterface = { title: '', items: [] };

  constructor(private router: Router) {}
  
  ngOnInit(): void {
    const itemCount = this.node?.items?.length || 0;
    if (itemCount <= 2) {
      this.columnCount = 6;
    } else if (itemCount >= 4) {
      this.columnCount = 3;
    } else {
      this.columnCount = 4;
    }
  }

  linkItem(item: ExploreItemInterface) {
    if (item.hyperlink && item.hyperlink.length > 0) {
      if (item.hyperlink.indexOf('//') < 0) {
        this.router.navigate([item.hyperlink]);
      } else if (typeof window !== 'undefined') {
        window?.open(item.hyperlink, '_blank');
      }
    }
  }
}
